(() => {
  const pairs = [
    ['.hl-option-size', 'properties[Size]'],
    ['.hl-option-length', 'properties[Length (inches)]'],
  ];
  const mounted = new WeakSet();
  const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  const nativeFieldSelector = '[data-hissa-letter],input[name="properties[Custom Size]"],textarea[name="properties[Custom Size]"]';

  function restoreNativeFields(root, form = null) {
    for (const input of root.querySelectorAll(nativeFieldSelector)) {
      if (!input.form || !root.contains(input.form) || (form && input.form !== form)) continue;
      if (input.disabled) input.disabled = false;
    }
  }

  function validateNativeLetter(root, form, event) {
    restoreNativeFields(root, form);
    const input = Array.from(root.querySelectorAll('[data-hissa-letter]')).find((field) => field.form === form);
    if (!input) return true;
    input.value = input.value.trim().normalize('NFC').toUpperCase();
    if (input.checkValidity()) return true;
    event.preventDefault();
    event.stopImmediatePropagation();
    input.focus();
    input.reportValidity();
    return false;
  }

  function positionLegacySizeGuide(root) {
    if (root.querySelector('variant-selects .hl-option-size')) return;

    const sourceLink = root.querySelector('.hl-size-guide-wrap .hl-size-guide-trigger');
    const modal = root.querySelector('#PopupModal-hl-size-guide, #PopupModal-popup_BqcW6c');
    for (const input of root.querySelectorAll('.tpo_option-container [name="properties[Size]"]')) {
      const container = input.closest('.tpo_option-container');
      const label = container?.querySelector('.tpo_option-label-container');
      if (!label || label.querySelector('[data-hissa-legacy-size-guide]')) continue;

      let control;
      if (sourceLink) {
        const targetId = sourceLink.getAttribute('href')?.slice(1);
        if (!targetId || !document.getElementById(targetId)) continue;
        control = sourceLink.cloneNode(true);
        control.removeAttribute('id');
      } else if (modal) {
        control = document.createElement('modal-opener');
        control.setAttribute('data-modal', `#${modal.id}`);
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-haspopup', 'dialog');
        button.textContent = document.documentElement.lang.toLowerCase().startsWith('ar')
          ? 'دليل المقاسات' : 'Size Guide';
        control.appendChild(button);
      } else {
        continue;
      }

      control.classList.add('hls-legacy-size-guide-control');
      control.setAttribute('data-hissa-legacy-size-guide', '');
      label.appendChild(control);
    }
  }

  function sync(root) {
    for (const [selector, name] of pairs) {
      const native = root.querySelector(`variant-selects ${selector}`);
      const chosen = native?.querySelector('input:checked, select');
      if (!chosen?.value) continue;
      for (const input of root.querySelectorAll(`input[name="${name}"]`)) {
        const container = input.closest('.tpo_option-container');
        if (!container) continue;
        container.classList.add('hissa-native-sizing-duplicate');
        container.setAttribute('aria-hidden', 'true');
        if (input.value === chosen.value) continue;
        const option = [...container.querySelectorAll('.tpo_option-type-selection')].find((el) =>
          (el.querySelector('.tpo_option_type_label')?.textContent || el.textContent).trim() === chosen.value
        );
        option?.click();
        if (input.value !== chosen.value) {
          setter.call(input, chosen.value);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.dispatchEvent(new Event('blur', { bubbles: true }));
        }
      }
    }
  }

  function mount(root) {
    if (mounted.has(root)) return;
    mounted.add(root);
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(root); });
    };
    root.addEventListener('change', (event) => {
      if (event.target.closest('variant-selects')) sync(root);
    });
    root.addEventListener('click', (event) => {
      const control = event.target.closest('button[type="submit"],input[type="submit"],[name="add"],.product-form__submit,.tpo-buy-it-now-btn');
      if (!control) return;
      const form = control.form || control.closest('form');
      if (!form || !root.contains(form)) return;
      if (!validateNativeLetter(root, form, event)) return;
      sync(root);
    }, true);
    root.addEventListener('submit', (event) => {
      const form = event.target;
      if (form.matches?.('form[action*="/cart/add"]') && !validateNativeLetter(root, form, event)) return;
      sync(root);
    }, true);
    root.addEventListener('formdata', (event) => {
      for (const [selector, name] of pairs) {
        const native = root.querySelector(`variant-selects ${selector}`);
        const chosen = native?.querySelector('input:checked, select');
        if (chosen?.value && event.formData.get(name) === chosen.value) {
          event.formData.delete(name);
        }
      }
    }, true);
    new MutationObserver((mutations) => {
      let childrenChanged = false;
      for (const mutation of mutations) {
        if (mutation.type === 'childList') childrenChanged = true;
        else if (mutation.type === 'attributes' && mutation.target.matches(nativeFieldSelector)) {
          restoreNativeFields(root, mutation.target.form);
        }
      }
      if (childrenChanged) {
        restoreNativeFields(root);
        positionLegacySizeGuide(root);
        schedule();
      }
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    restoreNativeFields(root);
    positionLegacySizeGuide(root);
    sync(root);
  }

  const start = () => document.querySelectorAll('product-info').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('product-info:loaded', start);
})();
